import CalendarFolder from 'owa-service/lib/contract/CalendarFolder';
import { AllCalendarEntry } from '../schema/AllCalendarEntry';

export const isCalendarEntryForWritableCalendar = (
    calendarEntry: AllCalendarEntry,
    calendarFolder: CalendarFolder
) => calendarEntry?.IsReadOnly && !!calendarFolder?.EffectiveRights?.CreateContents;
